// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2olpB","bigColWidth":"Table_bigColWidth__32uO7","biggerColWidth":"Table_biggerColWidth__1-V3E","row":"Table_row__1OuIa","col":"Table_col__1JKeQ"};